import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Form, Modal } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import mantenimiento from '../img/mantenimiento.jpg';
import reparadorelectro from '../img/reparador-electro.jpg';
import jardinero from '../img/jardinero.jpg';
import seguridad from '../img/seguridad.jpg';
import fumigador from '../img/fumigador.jpg';
import limpieza from '../img/limpieza.jpg';
import piscina from '../img/piscina.jpg';
import varios from '../img/varios.jpg';
import mantenimiento01 from '../img/albanil1.jpg';
import mantenimiento02 from '../img/albanil2.jpg';
import mantenimiento03 from '../img/albanil3.jpg';
import reparador01 from '../img/reparadora-celular.jpg';
import reparador02 from '../img/reparadora-celular2.jpg';
import jardinero01 from '../img/jardinero1.jpg';
import jardinero02 from '../img/jardinero2.jpg';
import jardinero03 from '../img/jardinero3.jpg';
import reparadortv from '../img/reparador-tv.jpg';
import fumigador1 from '../img/fumigador1.jpg';
import fumigador2 from '../img/fumigador2.jpg';
import piscina1 from '../img/piscina1.jpg';
import piscina2 from '../img/piscina2.jpg';
import domestica1 from '../img/domestica1.jpg';
import domestica2 from '../img/domestica2.jpg';
import domestica3 from '../img/domestica3.jpg';
import gomero from '../img/gomero.jpg';
import cerrajero from '../img/cerrajero.jpg';
import maestroparticular from '../img/maestro-particular.jpg';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const ServiceLink = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const selectedCity = searchParams.get('city') || 'Todas las ciudades';
    const selectedCat = searchParams.get('service'); // Puede ser un ID de categoría

    const [filter, setFilter] = useState(""); // Estado para el filtro de búsqueda
    const [showModal, setShowModal] = useState(false);
    const [selectedService, setSelectedService] = useState(null);
    const [taskers, setTaskers] = useState([]);
    const [categoryDetails, setCategoryDetails] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPageData = async () => {
            setLoading(true);
            try {
                // 1. Construir la URL para los taskers, incluyendo la categoría si está presente
                let taskerUrl = `${API_URL}/api/taskers?city=${encodeURIComponent(selectedCity)}`;
                if (selectedCat) {
                    taskerUrl += `&category=${encodeURIComponent(selectedCat)}`;
                }
                const taskersResponse = await fetch(taskerUrl);
                const taskersData = await taskersResponse.json();
                setTaskers(taskersData);

                // 2. Obtener detalles de la categoría si se seleccionó una
                if (selectedCat) {
                    // Asumimos que existe un endpoint para obtener detalles de una categoría por su ID
                    const categoryResponse = await fetch(`${API_URL}/api/categories/${selectedCat}`);
                    const categoryData = await categoryResponse.json();
                    // Asumimos que la API devuelve un objeto con { name, description, features, image }
                    // Nota: 'features' y 'image' deberían venir del backend. Usamos datos estáticos como fallback.
                    setCategoryDetails({
                        title: `🌟 ${categoryData.name} 🌟`,
                        description: categoryData.description || "Descripción no disponible.",
                        features: categoryData.features || [],
                        image: categoryData.image || varios
                    });
                } else {
                    // Datos genéricos si no se selecciona ninguna categoría
                    setCategoryDetails({ title: "Todos los Servicios", image: varios, description: "Explora la lista de profesionales disponibles en tu ciudad.", features: ["Filtra por nombre o descripción.", "Encuentra ayuda para cualquier tarea.", "Contratación fácil y segura."] });
                }
            } catch (error) {
                console.error("Error cargando datos de la página:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchPageData();
    }, [selectedCity, selectedCat]);

    // Función para abrir el modal con los detalles del servicio
    const handleShow = (service) => {
        setSelectedService(service);
        setShowModal(true);
    };

    const filteredServices = taskers
        .filter(tasker => tasker.name.toLowerCase().includes(filter.toLowerCase()) || (tasker.description && tasker.description.toLowerCase().includes(filter.toLowerCase())));

    if (loading) {
        return <Container className="my-5 text-center"><p>Cargando profesionales...</p></Container>;
    }

    return (
        <Container className="my-5 local-hire-design position-relative">
            <h5 className="text-primary fw-bold text-center font-montserrat">Servicios en {selectedCity}</h5>
            {categoryDetails && <Row>
                <Col md={5} className="mb-4">
                    <Card className="shadow-lg p-2 border-0">
                        <Card.Body>
                            <Card.Title className="text-center text-primary fw-bold">{categoryDetails.title}</Card.Title>
                            <Card.Text className="mt-3 text-muted">{categoryDetails.description}</Card.Text>
                            <ul>
                                {categoryDetails.features.map((feature, index) => (
                                    <li key={index}>{feature}</li>
                                ))}
                            </ul>
                            <div className="text-center mt-4">
                                <Button variant="success" size="sm" href="/contact">📞 Contáctanos hoy</Button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={7} className="mb-4">
                    <img src={categoryDetails.image} alt={categoryDetails.title} className="img-fluid rounded" />
                </Col>
            </Row>}

            {/* Campo de Búsqueda */}
            <Form.Control
                type="text"
                placeholder="Buscar servicio..."
                className="mb-4"
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
            />

            {/* Sección de Cards Filtradas */}
            <Row>
                {filteredServices.length > 0 ? filteredServices.map((service, index) => (
                    <Col md={4} key={index} className="mb-4">
                        <Card className="shadow-sm border-0 rounded-lg">
                            <Row className="g-0 align-items-center">
                                <Col xs={4} className="text-center">
                                    <Card.Img variant="left" src={service.image || "https://via.placeholder.com/100"} alt={service.name} className="rounded img-fluid" style={{ width: "100px", margin: "0 auto" }} />
                                </Col>
                                <Col xs={8}>
                                    <Card.Body>
                                        <Card.Title className="text-primary fw-bold">{service.name}</Card.Title>
                                        <Card.Text className="text-muted">{service.description ? service.description.substring(0, 50) + "..." : "Sin descripción"}</Card.Text>
                                        <Card.Text className="fw-bold">{service.name}</Card.Text>
                                        <Card.Text className="text-warning">{service.rating}</Card.Text>
                                        <Button variant="primary" className="mt-2 rounded-pill px-4"
                                            onClick={() => handleShow(service)}
                                        >
                                            Ver más
                                        </Button>
                                    </Card.Body>
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                )) : (
                    <Col><p className="text-center text-muted">No se encontraron profesionales en esta zona.</p></Col>
                )}
            </Row>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="text-primary">{selectedService?.name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedService && (
                        <>
                            <div className="text-center">
                                <img
                                    src={selectedService.image || "https://via.placeholder.com/150"}
                                    alt={selectedService.name}
                                    className="img-fluid rounded mb-3"
                                    style={{ maxWidth: "150px" }}
                                />
                            </div>
                            <h5 className="text-center text-warning">{selectedService.rating}</h5>
                            <p className="text-muted"><strong>Servicios:</strong> {selectedService.services && Array.isArray(selectedService.services) ? selectedService.services.join(", ") : "Varios"}</p>
                            <p className="text-muted"><strong>Descripción:</strong> {selectedService.description}</p>

                            <h6 className="fw-bold mt-3">Reseñas de clientes:</h6>
                            <ul className="list-unstyled">
                                {selectedService.comments?.map((review, i) => (
                                    <li key={i} className="mb-2">
                                        <strong>{review.customer_name}:</strong> {review.comment}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" className="mt-2 rounded-pill px-4">
                        Contratar
                    </Button>
                    <Button variant="secondary" className="mt-2 rounded-pill px-4" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default ServiceLink;
